import Cookie from "./Cookie";

export default class Parameters {
    constructor() {
        this.params = new URLSearchParams(window.location.search);
    }

    getLang() {
        let lang = this.params.get('lang');

        lang = !!lang && lang.length === 2
            ? lang
            : Cookie.get(Cookie.LANG);

        lang = !!lang && lang.length === 2
            ? lang
            : 'ru';

        return lang;
    }

    getEventId() {
        let event_id = this.params.get('event_id');

        let eventId = parseInt(event_id) > 0
            ? event_id
            : 0;

        return parseInt(eventId);
    }

    getMemberId() {
        let id = this.params.get('id');
        return !!id ? id : '';
    }
};